<form [formGroup]="searchForm" class="mb-0">
    <mat-form-field class="example-form-field">
        <mat-label>{{'SHARED.SEARCH_BOX' | translate}}</mat-label>
        <input matInput type="text" formControlName="searchString">
        <button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="searchForm.reset()" [disabled]="showLoading">
          <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>    
</form>  